import { render, staticRenderFns } from "./settingCompanyAdditionalInfo.vue?vue&type=template&id=ed761cd0&scoped=true&"
import script from "./settingCompanyAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./settingCompanyAdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanyAdditionalInfo.vue?vue&type=style&index=0&id=ed761cd0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed761cd0",
  null
  
)

export default component.exports